export default __webpack_public_path__ + "static/media/tablet-page.1ba90251.jpg";